import { Cushion, FlexContainer, Rectangle, Typography } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import ClubLink from '../club-link';
import Table from '../table/shortened';

const SidebarTable = ({ data }) => {
  if (!data) return null;
  const table = data.tables?.[0];
  if (!table) return null;

  return (
    <div>
      <Rectangle radius="8px" style={{ overflow: 'hidden' }} component="div">
        <ClubLink route="team.league_table" params={{ teamId: data.teamId, tableId: table.id }}>
          <a>
            <FlexContainer
              flexDirection="column"
              style={{ width: '100%', backgroundColor: '#fff' }}
            >
              <Rectangle fill="#000" component="div">
                <Cushion vertical="small">
                  <Typography color="white" preset="title" align="center" size={14} component="div">
                    {table.name}
                  </Typography>
                </Cushion>
              </Rectangle>
              <Rectangle radius="0 0 8px 8px" border="1px solid #b8b8b8" component="div">
                {table && <Table {...table} isV2 isMobile />}
              </Rectangle>
            </FlexContainer>
          </a>
        </ClubLink>
      </Rectangle>
    </div>
  );
};

SidebarTable.propTypes = {
  data: PropTypes.shape({
    teamId: PropTypes.number,
    teamName: PropTypes.string,
    tables: PropTypes.arrayOf(PropTypes.shape()),
  }),
};

SidebarTable.defaultProps = {
  data: {},
};

export default SidebarTable;
